import { Switch, Tooltip, useNotifications } from '@sequencehq/core-components'

import { useAtom, useAtomValue } from 'jotai'
import {
  invoiceCustomerIdAtom,
  invoiceIdAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useGoCardlessAvailability } from 'Invoices/hooks/useGoCardlessAvailability'
import { isPostInvoiceSettingsPendingAtom } from './paymentSettings.atoms'

export const GoCardlessPaymentSettingsSwitch = () => {
  const { displayPromiseNotification } = useNotifications()

  const [invoiceSettingsPending, setInvoiceSettingsPending] = useAtom(
    isPostInvoiceSettingsPendingAtom
  )

  const { mutateAsync: createPaymentSettings, isPending: createIsPending } =
    useMutation(dashboard20240730Client.postInvoiceSettings, {
      onMutate: () => {
        setInvoiceSettingsPending(true)
      },
      onSettled: () => {
        setInvoiceSettingsPending(false)
      }
    })

  const { isEnabled, isAvailable, disabledReason } = useGoCardlessAvailability()
  const invoiceId = useAtomValue(invoiceIdAtom)
  const customerId = useAtomValue(invoiceCustomerIdAtom)

  const updateInvoiceSettings = async (
    isGoCardlessPaymentSelected: boolean
  ) => {
    await displayPromiseNotification(
      createPaymentSettings({
        invoiceId: invoiceId ?? '',
        customerId,
        paymentProvider: isGoCardlessPaymentSelected ? 'GOCARDLESS' : 'NONE'
      }),
      {
        loading: 'Updating GoCardless settings...',
        success: 'Invoice GoCardless settings updated',
        error: 'Could not update invoice GoCardless settings'
      }
    )
  }

  return (
    <Tooltip label={disabledReason} isDisabled={!disabledReason}>
      <Switch
        data-testid="invoiceTerms.goCardlessSwitch"
        size="md"
        checked={isEnabled}
        onChange={(value: boolean) => void updateInvoiceSettings(value)}
        disabled={
          isEnabled || !isAvailable || createIsPending || invoiceSettingsPending
        }
      />
    </Tooltip>
  )
}
